export interface Attachment {
  id: number
  file_type: 'image' | 'audio' | 'video' | 'file'
  content_type?: string
  data_url: string
  thumb_url?: string
  extension?: string
  file_size?: number
}

export interface ChatMessage {
  id: number
  content: string | null
  message_type: number
  created_at: number
  attachments?: Attachment[]
  sender?: {
    name?: string
    available_name?: string
    type?: string
    thumbnail?: string
  }
  status?: string
  /** Nota interna do Chatwoot — visível só para a equipe, nunca entregue ao cliente pelo canal (WhatsApp etc). */
  private?: boolean
}

export interface ProcessedMsg extends ChatMessage {
  showAvatar: boolean
}

export interface LabelItem {
  id: number
  title: string
  color: string
}

export interface AgentItem {
  id: number
  name: string
  thumbnail: string
}

export type Priority = 'urgent' | 'high' | 'medium' | 'low' | 'none'

export const PRIORITY_LABELS: Record<Priority, string> = {
  urgent: 'Urgente',
  high:   'Alta',
  medium: 'Média',
  low:    'Baixa',
  none:   'Nenhuma',
}

export const PRIORITY_COLORS: Record<Priority, string> = {
  urgent: '#dc2626',
  high:   '#ea580c',
  medium: '#ca8a04',
  low:    '#2563eb',
  none:   '',
}

export interface WaTpl {
  id: string
  name: string
  category: string
  language: string
  status: string
  components: any[]
  sub_category?: string
}

export interface SLABadge {
  label: string
  time: string
  status: 'breached' | 'atRisk'
}
